<h2 mat-dialog-title>Search Products</h2>
<div class="search-box">
  <glxy-form-field>
    <input #searchInput matInput [placeholder]="'Search by Product ID or Name'" autocomplete="off" />
  </glxy-form-field>
</div>
<mat-dialog-content>
  <ng-container *ngIf="state()">
    <mat-nav-list *ngIf="state().searchTerm; else recentProductsList">
      <h3 matSubheader>
        <span *ngIf="state().products?.length; else noResults">Search results</span>

        <ng-template #noResults>
          <ng-container *ngIf="!loading()">No products found</ng-container>
        </ng-template>
      </h3>
      <app-product-row
        *ngFor="let product of state().products"
        [product]="product"
        (productSelected)="switchProduct(product)"
      />

      <ng-container *ngIf="!loading(); else loadingSpinner">
        <glxy-infinite-scroll-trigger
          *ngIf="state()?.hasMore"
          (isVisible)="loadMore(state().cursor)"
        ></glxy-infinite-scroll-trigger>
      </ng-container>
    </mat-nav-list>
  </ng-container>

  <ng-template #recentProductsList>
    <mat-nav-list *ngIf="recentProducts()">
      <h3 matSubheader *ngIf="recentProducts().length > 0">Recent Products</h3>
      <app-product-row
        *ngFor="let product of recentProducts()"
        [product]="product"
        (productSelected)="switchProduct(product)"
      />
    </mat-nav-list>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>

<ng-template #loadingSpinner>
  <glxy-loading-spinner [size]="'small'" [fullWidth]="true"></glxy-loading-spinner>
</ng-template>
